import {
  GIFT_CARDS_DETAILS_ADD,
  GIFT_CARDS_DETAILS_REMOVE,
} from '~/redux/actions/types'

export const addDetails = (details) => {
  return {
    type: GIFT_CARDS_DETAILS_ADD,
    payload: details,
  }
}

export const removeDetails = () => {
  return {
    type: GIFT_CARDS_DETAILS_REMOVE,
  }
}
